import { useRoute } from '@react-navigation/native';
import { useSelector } from 'react-redux';
import { parseRouteParamAsNumber } from '@helpers';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { selectSelectedItem } from '@reducers/machines';
import { selectJobsData } from '@reducers/details';
import { useManageOPInformationTabsCrossIcon } from '@components/operatorPanel/hooks/useManageOPInformationTabsCrossIcon';

export const useManageProductionOrderContentDifferentModes = () => {
  const selectedItem = useSelector(selectSelectedItem);
  const jobs = useSelector(selectJobsData);

  const route = useRoute();
  const { productionOrder: title } = useTitle();

  const jobId = parseRouteParamAsNumber(route.params?.selectedProductionOperationId);

  const { onCrossIconPress } = useManageOPInformationTabsCrossIcon();

  return {
    selectedItem,
    jobs,
    title,
    jobId,
    onClose: onCrossIconPress,
  };
};
